import 'regenerator-runtime/runtime'

const [ w, d ] = [ window, document ]

const replace_contHeader = html => d.querySelector('.mainImg h2').innerHTML = html

const init = async key => {
  let id = w.query_string('article') || 1
  let post_id = id
  let mainImg = d.querySelector('.mainImgInner')
  let getArticleData = await $.getJSON('/asset/api/getArticles/', { content:'house', post_id })
  let gmenu_path
  let nav,nav_foot
  if( id < 100 ) id = ( '0' + id ).substr( -2 )
  switch( key ){
    case 'house':
      replace_contHeader(`<span>${getArticleData[0].title}</span>`)
      mainImg.classList.add(`is-${key}-${id}`)
      gmenu_path = '/house/'
      break
    case 'wood':
      replace_contHeader(`<span class="font-sans-serif">木材へのこだわり</span>`)
      mainImg.classList.add(`is-${key}`)
      nav = await $.get('/asset/html/nav-wood.html')
      $(() => {
        let $nav = $(nav).currentMenu({mode:0,default:999})
        $nav.clone(true).appendTo('.mainImgInner')
        $nav.clone(true).appendTo('.block_foot')
      })
      d.querySelectorAll('[data-load-html="nav-house"],.nav-house')
        .forEach(e => e.parentNode.removeChild(e))
      gmenu_path = '/house/'
      break
    case 'perform':
      replace_contHeader(`<span class="font-sans-serif">住まいの性能</span>`)
      mainImg.classList.add(`is-${key}`)
      nav = await $.get('/asset/html/nav-perform.html')
      nav_foot = await $.get('/asset/html/nav-perform-foot.html')
      $(() => {
        let $nav = $(nav).currentMenu({mode:0,default:999})
        let $nav_foot = $(nav_foot).currentMenu({mode:0,default:999})
        $nav.clone(true).appendTo('.mainImgInner')
        $nav_foot.clone(true).appendTo('.block_foot')
      })
      d.querySelectorAll('[data-load-html="nav-house"],.nav-house')
        .forEach(e => e.parentNode.removeChild(e))
      gmenu_path = '/house/?mode=detail&article=9'
      break
  }
  $(() => {
    w.load['header'].done(() => {
      $('.p-gnav__list').each((i,obj) => $(obj).currentMenu({url:gmenu_path}) )
    })
    w.load['loadHtml'].done(() => {
      $('[data-plugin="currentMenu"]').currentMenu({mode:0,default:999})
    })
  })
}

export function HOUSE () {
  d.addEventListener('DOMContentLoaded', () => init('house') )
}

export function WOOD () {
  d.addEventListener('DOMContentLoaded', () => init('wood') )
}

export function PERFORMANCE () {
  d.addEventListener('DOMContentLoaded', () => init('perform') )
}